<template>
  <div id="app">
    <v-app v-if="loading" id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center row wrap>
            <v-flex xs12 class="text-center">
              <img alt="Sopheo" src="@/statics/icons/android-chrome-512x512.png" style="max-width:250px">
              <v-flex xs12 class="text-center">
                <h1 :class="`display-${size} font-weight-regular`">
                  Sopheo
                </h1>
              </v-flex>
            </v-flex>
          </v-layout>
          <inner-loading :visible="true" />
        </v-container>
      </v-content>
    </v-app>
    <router-view v-else />
  </div>
</template>

<script>

import InnerLoading from '@/components/InnerLoading'
import { EventBus } from '@/store/EventBus.js'
export default {
  name: 'App',
  components: { InnerLoading },
  data () {
    return {
      loading: true,
      errors: [],
      errorsTimer: null
    }
  },
  metaInfo: {
    title: 'Sopheo'
  },
  computed: {
    size () {
      return this.$vuetify.breakpoint.xsOnly ? 3 : 4
    }
  },
  watch: {
    errors (value) {
      if (value.length) {
        let last = value[value.length - 1]
        if (value.filter(e => e === last).length === 1) {
          this.$notify({
            message: last,
            type: 'warning',
            class: 'black--text',
            icon: 'mdi-alert',
            position: 'top-right'
          })
        }
        if (this.errorsTimer === null) {
          this.errorsTimer = setTimeout(() => {
            this.$set(this, 'errors', [])
            this.errorsTimer = null
          }, 3000)
        }
      }
    }
  },
  created () {
    EventBus.$on('configLoad', () => this.start())
    this.$store.dispatch('api/INIT_CONFIG')

    this.axios.interceptors.request.use((config) => {
      if (config.headers.Authorization) config.headers.Authorization = ''
      if (!config.headers.common.Authorization && this.$store.getters.token) {
        config.headers.Authorization = this.$store.getters.token
        this.$store.dispatch('AUTH_UPDATE', this.$store.getters.token)
      }
      return config
    }, (error) => { return Promise.reject(error) })

    this.axios.interceptors.response.use((response) => {
      if (response.headers && response.headers.token && response.headers.token !== 'undefined') {
        this.$store.dispatch('AUTH_UPDATE', response.headers.token)
      }
      return response
    }, (error) => {
      return new Promise((resolve, reject) => {
        this.responsError(error)
        throw error
      })
    })
  },
  methods: {
    start () {
      EventBus.$off('configLoad')
      this.$store.dispatch('AUTH_CHECK')
      this.$store.watch((state, getters) => getters.isAuthenticated, (isAuthenticated) => {
        // console.log('isAuthenticated', isAuthenticated)
        if (isAuthenticated) {
          this.loadBaseEntities()
          setTimeout(() => {
            if (this.$router.history.current.name === 'login' || this.$router.history.current.path === '/') {
              this.$router.push('/incidencias')
            }
          }, 1000)
        } else this.$router.push('/login')
      }, { deep: true })
      this.loading = false
    },
    loadBaseEntities () {
      let queryString = ''
      let cliente = this.$store.getters.getProfile.Cliente
      let instalacion = this.$store.getters.getProfile.Instalacion

      queryString = this.$store.getters.Cliente && cliente ? `/${cliente}` : ''
      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'cliente',
        queryString: queryString,
        props: { props: ['Estado'] },
        force: true
      })

      queryString = this.$store.getters.Cliente && cliente ? `?cliente=${cliente}` : ''
      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'instalacion',
        value: ['Cliente', 'Instalacion'],
        queryString: queryString,
        props: { props: ['NoActiva'] },
        force: true
      })

      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'tipoIncidencia',
        label: 'Descripcion',
        force: true
      })
      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'incidenciaEstado',
        label: 'Descripcion',
        force: true
      })

      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'tecnico',
        force: true
      })

      queryString = this.$store.getters.Cliente && cliente ? `?cliente=${cliente}` : ''
      queryString = queryString && instalacion ? `${queryString}&instalacion=${instalacion}` : queryString
      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'programa',
        queryString: queryString,
        force: true
      })

      this.$store.dispatch('entities/LOAD_ENTITY', {
        entity: 'prioridad',
        label: 'Descripcion',
        force: true
      })
    },
    responsError (error) {
      let message = ''
      console.log(JSON.parse(JSON.stringify(error)))
      if (error.response && error.response.status >= 300) {
        message = error.response.status + '  '
        if (typeof error.response.data === 'string' && error.response.data.length) message += error.response.data
        else message += error.response.data.Message || error.response.statusText
        if (error.response.status === 401 && error.response.statusText === 'Unauthorized Token Expired') {
          this.$store.dispatch('AUTH_LOGOUT')
        } else if (error.response.data) {
          if (error.response.data.ModelState) {
            let ModelState = error.response.data.ModelState
            Object.keys(ModelState).forEach(field => {
              message += field.split('.').pop() + ' => '
              if (Array.isArray(ModelState[field])) {
                Object.keys(ModelState[field]).forEach(key => { message += ` · ${ModelState[field][key]} ` })
              } else {
                message += field.split('.').pop()
              }
            })
          } else if (error.response.data.ExceptionMessage) {
            message += error.response.data.ExceptionMessage || ''
          }
        }
      } else if (error.toString() === 'Error: Network Error') {
        message = 'Network Error'
      } else {
        // Timeout Exceeded
        message = window.capitalize(error.message)
      }

      if (message) {
        this.errors.push(message)
      }
    }
  }
}
</script>
